(() => {
  const pages = document.querySelectorAll('[data-wbp-page]');

  pages.forEach((root) => {
    const heroCta = root.querySelector('[data-wbp-hero-cta]');
    const sticky = root.querySelector('[data-wbp-sticky]');
    const offer = root.querySelector('[data-wbp-offer]');
    const reviews = root.querySelector('[data-wbp-reviews]');
    const productHandle = root.dataset.productHandle || 'wrist-massager';

    const pushEvent = (event, details = {}) => {
      if (!Array.isArray(window.dataLayer)) return;

      window.dataLayer.push({
        event,
        product_handle: productHandle,
        ...details,
      });
    };

    root.querySelectorAll('[data-wbp-cta]').forEach((link) => {
      link.addEventListener('click', () => {
        pushEvent('pregnancy_listicle_cta_click', {
          cta_location: link.dataset.wbpLocation || 'unknown',
        });
      });
    });

    if (heroCta && sticky) {
      const scroller =
        document.querySelector('.page-wrapper') || window;
      const updateSticky = () => {
        const heroGone = heroCta.getBoundingClientRect().bottom < 0;
        sticky.setAttribute('aria-hidden', heroGone ? 'false' : 'true');
      };
      scroller.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('scroll', updateSticky, { passive: true });
      updateSticky();
    }

    const observeOnce = (element, event) => {
      if (!element || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          pushEvent(event);
          observer.disconnect();
        },
        { threshold: 0.25 }
      );

      observer.observe(element);
    };

    observeOnce(offer, 'pregnancy_listicle_offer_view');
    observeOnce(reviews, 'pregnancy_listicle_review_view');
  });
})();

const wbScrollToEl = (target, offset) => {
  [
    document.querySelector('.page-wrapper'),
    document.scrollingElement,
    document.documentElement,
    document.body,
  ].forEach((sc) => {
    if (!sc || !sc.getBoundingClientRect) return;
    try {
      const isRoot =
        sc === document.scrollingElement ||
        sc === document.documentElement ||
        sc === document.body;
      let top = isRoot
        ? target.getBoundingClientRect().top +
          (window.pageYOffset || sc.scrollTop) -
          offset
        : target.getBoundingClientRect().top -
          sc.getBoundingClientRect().top +
          sc.scrollTop -
          offset;
      if (top < 0) top = 0;
      const prev = sc.style.scrollBehavior;
      sc.style.scrollBehavior = 'auto';
      sc.scrollTop = top;
      sc.style.scrollBehavior = prev;
    } catch (e) {}
  });
};

/* Same-page anchor scroll: the theme scrolls a custom .page-wrapper and
   cancels native hash navigation, so pin instant scrolls over a few frames. */
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;
  const target = document.getElementById(a.getAttribute('href').slice(1));
  if (!target) return;
  e.preventDefault();
  let tries = 0;
  const iv = setInterval(() => {
    wbScrollToEl(target, 80);
    if (++tries >= 12) clearInterval(iv);
  }, 60);
});
